import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.CustomPricePoint.Import.IRequest;
type Headers = Api.Core.CustomPricePoint.Import.IHeaders;
type Response = Api.Core.CustomPricePoint.Import.IResponse;
const url = '/api/ProductManagement/CustomPricePoint/ImportFromExcel/:productId';
export async function customPricePointImportFromExcelApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    body,
    url: createPathFromRoute(url, { productId: body.productId }, null),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
